var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009201"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1204",
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1206",
    d: "M19.5 18.25C17.8675 15.2318 15.1174 13.25 12 13.25C8.88261 13.25 6.13255 15.2318 4.5 18.25",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1205",
    cx: 12,
    cy: 9.5,
    r: 3.75,
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ca13d6b4374d7801bf7c51105a00ae65.svg";
export { ForwardRef as ReactComponent };